import { configure } from 'mobx';
import { browserHistory, HistoryAdapter } from 'mobx-state-router';
import { RootStore } from 'stores';

function initMobX() {
    // Enable strict mode for MobX.
    // This disallows state changes outside of an action.
    configure({ enforceActions: 'never' });
}

function initStores() {
    // Create the rootStore
    const rootStore = new RootStore();
    const { prefStore, routerStore, authStore } = rootStore;

    // Load preferences
    authStore.init()
    prefStore.init();

    // Observe history changes
    const historyAdapter = new HistoryAdapter(routerStore, browserHistory);
    historyAdapter.observeRouterStateChanges();

    return rootStore;
}

export function initApp() {
    initMobX();
    return initStores();
}